import axios from 'axios'
import environmentConfig from '@/config/environmentConfig'

export default class UtilsService {
  static async checkUserOnNet(msisdn) {
    return await axios.post(`${environmentConfig.upstreamService}/check-user-on-net`, {
      msisdn
    })
  }
}
